// extracted by mini-css-extract-plugin
export var RecruitHeader = "RecruitHeader-module--RecruitHeader--1Yjlr";